<section>
  <h1>Create <span class="emphasis">Disconnect</span> Ticket</h1>

  @if (disconnectTxGroup) {
    <form
      [formGroup]="disconnectTxGroup"
      [ngClass]="{ 'form-submit-attempt': formSubmitAttempted }"
      autocomplete="off"
    >
      @if (disconnectReasons.length > 0) {
        <h2>General Information</h2>
        <h3>Reason for Disconnect</h3>
        <mat-form-field (keyup)="canSubmit()">
          <mat-label>Please select</mat-label>
          <mat-select formControlName="reason" (keyup)="canSubmit()">
            @for (reason of disconnectReasons; track reason) {
              <mat-option [value]="reason">
                {{ reason }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        @if (disconnectTxGroup.value.reason === 'Other') {
          <mat-form-field>
            <mat-label>Enter reason</mat-label>
            <input
              matInput
              type="text"
              formControlName="otherReasonDetails"
              (keyup)="canSubmit()"
            />
          </mat-form-field>
        }
      }

      <h2>Contact Information</h2>
      <app-primary-reporter
        [formRef]="disconnectTxGroup"
        [reporters]="primaryReporters"
        [altContact]="false"
        (usersLoaded)="usersLoaded()"
      >
      </app-primary-reporter>

      <h2>Service Information</h2>
      <app-multiple-service-location
        [formRef]="disconnectTxGroup"
        [inlineErrors]="inlineErrors"
        [selectedServiceId]="selectedServiceId"
        (servicesLoaded)="servicesLoaded()"
        (keyup)="canSubmit()"
      >
      </app-multiple-service-location>

      <h3>Additional comments</h3>
      <mat-form-field class="custom-textarea">
        <mat-label
          >Any additional feedback or comments you'd like to give?</mat-label
        >
        <textarea matInput formControlName="comments" rows="5"></textarea>
      </mat-form-field>

      @if (isSubmitting) {
        <div class="loading-indicator">
          <mat-spinner [diameter]="25"></mat-spinner>
        </div>
      } @else if (submissionError) {
        <div class="server-error">
          <div class="custom-icon inline_error"></div>
          <div class="error-message">{{ errorMessage }}</div>
        </div>
      } @else if ((inlineErrors | json) !== '{}') {
        <div class="form-error">
          <div class="custom-icon inline_error"></div>
          <div class="error-message">
            Please fill out the required field(s) circled in red.
          </div>
        </div>
      }

      <div class="flex justify-end mt-6">
        <button
          class="primary-button m-0"
          (click)="submitTicket()"
          [disabled]="isLoadingServices || loadingUsers || isSubmitting"
        >
          <span>Submit ticket</span>
        </button>
      </div>
    </form>
  }
</section>
